import React from "react";
import "bootstrap/dist/css/bootstrap.css";


const Skills=()=>{
  const skills=[
    {
      name:"ReactJS",
      image:"/images/services/React-icon.svg.png",
      color:"shadow-md hover:scale-105 duration-500 py-2 rounded-lg shadow-cyan-200"
    },
    {
      name:"JavaScript",
      image:"/images/services/JavaScript-logo.png",
      color:"shadow-md hover:scale-105 duration-500 py-2 rounded-lg shadow-yellow-300"
    },
    {
      name:"Bootstrap",
      image:"/images/services/Bootstrap_logo.svg.png",
      color:"shadow-md hover:scale-105 duration-500 py-2 rounded-lg shadow-indigo-700"
    },
    // {
    //   name:"Git",
    //   image:"/images/services/git.png",
    //   color:"shadow-md hover:scale-105 duration-500 py-2 rounded-lg shadow-orange-300"
    // },
    {
      name:"Tailwind CSS",
      image:"/images/services/Tailwind_CSS_Logo.svg.png",
      color:"shadow-md hover:scale-105 duration-500 py-2 rounded-lg shadow-cyan-700"
    },
    {
      name:"CSS",
      image:"/images/services/CSS3_logo.svg.png",
      color:"shadow-md hover:scale-105 duration-500 py-2 rounded-lg shadow-blue-400"
    },
    {
      name:"HTML",
      image:"/images/services/html5-icon-13.jpg",
      color:"shadow-md hover:scale-105 duration-500 py-2 rounded-lg shadow-orange-300"
    },

  ]
    return(
    <div className="w-full md:h-screen" name="skills">
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">My Skills</p>
        </div>
        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {
            skills.map((skill)=>(
              <div className={skill.color}>
              <img src={skill.image} className="w-20 mx-auto" alt={skill.name}/>
              <p className="mt-4">{skill.name}</p>
              </div>
            ))
          }
                     
        </div>
      </div>
    </div>
    )
}

export default Skills;